import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { Link } from "react-router-dom"
import { readableColor } from "polished"

export const StyledLink = styled(Link)`
  width: 100%;
  height: 100%;
  padding: 2rem;
  text-decoration: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  ${breakpoint("tablet")`
    align-content: center;
    flex-direction: row;
  `}
`

export const Datum = styled.div`
  margin-bottom: 1rem;

  ${breakpoint("tablet")`
    margin-bottom: 0;
    flex: 0 0 25%;

    ${(props) =>
      props.large &&
      `
      flex: 0 0 40%;
    `}
  `}
`

export const Title = styled.span`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
  color: ${(props) => props.theme.colors.tables.headings};
`

export const Content = styled.span`
  display: flex;
  font-size: 1.2rem;
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
  color: ${(props) =>
    readableColor(
      props.theme.colors.secondary,
      props.theme.colors.buttons.darkColor,
      props.theme.colors.buttons.lightColor,
      false
    )};
`

export const ArrowContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
